import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/mneno/apps/web-app/src/studio/StudioClientShell.tsx");
;
import(/* webpackMode: "eager" */ "/srv/mneno/node_modules/.pnpm/next@16.4.3_@types+node@26.6.6_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/link.js");
